import { Application } from "stimulus";

import {
  HeroCarouselController,
  CollectionController,
  LineItemController,
  QuickCartController,
  ProductCarouselController,
  ProductController,
  MapController,
  UIController,
  SearchController,
  TestimonialCarouselController,
  CartController,
  SubscriptionFormController,
  FeaturedCollectionController,
  EnquiryFormController,
  QuickshopController,
  CarouselController,
} from "./controllers";

import { getFeaturedItemImage, productCardAnchorHandler } from "./helpers";

import { Filter } from "./components";

class Jarvis {
  constructor() {
    console.log("Hello from Jarvis!");
  }

  registerControllers() {
    const application = Application.start();
    application.register("carousel", CarouselController);
    application.register("hero-carousel", HeroCarouselController);
    application.register("collection", CollectionController);
    application.register("quick-cart", QuickCartController);
    application.register("line-item", LineItemController);
    application.register("product-carousel", ProductCarouselController);
    application.register("product", ProductController);
    application.register("map", MapController);
    application.register("ui", UIController);
    application.register("search", SearchController);
    application.register("testimonial-carousel", TestimonialCarouselController);
    application.register("cart", CartController);
    application.register("subscription-form", SubscriptionFormController);
    application.register("featured-collection", FeaturedCollectionController);
    application.register("enquiry-form", EnquiryFormController);
    application.register("quickshop", QuickshopController);
  }
}

function init() {
  const jarvis = new Jarvis();

  jarvis.registerControllers();
  getFeaturedItemImage();
  productCardAnchorHandler();

  if (
    window.location.pathname.includes("/collections/") ||
    window.location.pathname.includes("/search/")
  ) {
    const filterTree = document.querySelector(".filter-tree__form");
    if (filterTree) {
      new Filter();
    }
  }
}

document.addEventListener("DOMContentLoaded", init);
